import { Injectable } from '@angular/core';
import { TimeInvoking } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class TimeInvokingService {
  protected timeInvoking = new TimeInvoking();

  constructor() {}

  invokeOnce(
    id: string,
    fn: (() => any) | (() => Promise<any>)
  ): Promise<void> {
    return this.timeInvoking.invokeOnce(id, fn);
  }
}
